import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { ApiBaseUrl } from "../../http";
import { PaginationResults } from "../user/user.type";
import { prepareHeaders } from "../user/user.api";
import { ITopic, TopicFormData } from "./topic.type";

export const TopicApi = createApi({
	reducerPath: "topicApi",
	tagTypes: ["topics"],
	baseQuery: fetchBaseQuery({
		baseUrl: `${ApiBaseUrl}/api/`,
		prepareHeaders,
	}),
	endpoints: (builder) => ({
		getTopics: builder.query<PaginationResults<ITopic>, void>({
			query: () => ({
				url: "topics/",
				method: "GET",
			}),
			providesTags: ["topics"],
		}),
		addOrUpdateTopic: builder.mutation<ITopic, { id?: number; data: TopicFormData }>({
			invalidatesTags: ["topics"],
			query: ({ id, data }) => {
				if (id) {
					return {
						url: `topics/${id}/`,
						method: "PUT",
						body: data,
					};
				}
				return {
					url: `topics/`,
					method: "POST",
					body: data,
				};
			},
		}),
		deleteTopic: builder.mutation<ITopic, number>({
			query: (id) => ({
				url: `topics/${id}/`,
				method: "DELETE",
			}),
			invalidatesTags: ["topics"],
		}),
	}),
});

export const { useGetTopicsQuery, useAddOrUpdateTopicMutation, useDeleteTopicMutation } = TopicApi;
